import { init as initUrl } from './url';
import createGuid from '../utils/guid';
var ACCS_SERVICE_ID_MAP = {
    my: 'lz-my-sync',
    ph: 'lz-ph-sync',
    th: 'lz-th-sync',
    id: 'lz-id-sync',
    vn: 'lz-vn-sync',
    sg: 'lz-sync',
};
function getSite() {
    var host = window.location.host;
    if (/\.lazada\./.test(host)) {
        return 'lazada';
    }
    else if (/\.lazada-seller\./.test(host)) {
        return 'lazada-seller';
    }
    else if (/\.daraz\./.test(host)) {
        return 'daraz';
    }
    else if (/\.shop\./.test(host)) {
        return 'shop';
    }
    else if (/\.aliexpress\./.test(host)) {
        return 'aliexpress';
    }
    else {
        return '';
    }
}
function getSiteSuffix(siteName) {
    if (!siteName) {
        return;
    }
    var host = window.location.host;
    var mat = host.match(new RegExp("(" + siteName + "..+)$"));
    if (mat) {
        return mat[1];
    }
    return;
}
var siteName = getSite();
var siteSuffix = getSiteSuffix(siteName);
var Normal = {
    userTypeMap: [
        1,
        2,
    ],
    userDefaultHeadMap: {
        1: '//sg-live.slatic.net/original/ebf238e7aa294b55f5198f2a709efa42.png',
        2: '//sg-live.slatic.net/original/0f460c08eaf10eaaada4bd51ef2af6ea.png',
    },
    messageTemplateInfo: {
        1: {
            cardType: '1',
            templateInfo: '{"txt":"${txt}", "translateTxt":"${translateTxt}"}',
        },
        2: {
            cardType: '2',
            templateInfo: '{"txt":"${txt}","activeContent":"${activeContent}"}',
        },
        3: {
            cardType: '3',
            templateInfo: '{"imgUrl":"${imgUrl}","osskey":"${osskey}","width":"${width}","height":"${height}"}',
        },
        4: {
            cardType: '4',
            templateInfo: '{"txt":"${txt}","imgUrl":"${imgUrl}"}',
        },
        10006: {
            cardType: 10003,
        },
        10007: {
            cardType: 10004,
        },
        10008: {
            cardType: 10005,
        },
        10009: {
            cardType: 10006,
        },
        10010: {
            cardType: 10007,
        }
    },
};
var Seller = {};
var Buyer = {};
export function getMtopAccsConfig(type, env, channel) {
    var accsAppKey;
    var accsAserverUrl;
    var mtopDomain;
    var accessKey;
    var accessToken;
    if (channel === 'youpik') {
        accessKey = 'minishop-pc-h5';
        accessToken = 'minishop-test-secret';
    }
    else {
        accessKey = 'lazada-pc-h5';
        accessToken = 'lazada-test-secret';
    }
    if (env === 'daily') {
        if (type === 'buyer') {
            accsAppKey = 'H5_60040221';
            mtopDomain = 'acs.waptest.lazada.test';
        }
        else if (type === 'seller') {
            accsAppKey = 'H5_60040234';
            mtopDomain = 'acs.waptest.lazada.test';
        }
        if (/(daraz|shop)/.test(window.location.host)) {
            accsAserverUrl = 'msgacs-m.lazada.sg';
        }
        else {
            accsAserverUrl = 'lazada-msgacs.m.taobao.com';
        }
    }
    else if (env === 'pre') {
        if (type === 'buyer') {
            accsAppKey = 'H5_24814220';
        }
        else if (type === 'seller') {
            accsAppKey = 'H5_24813843';
        }
        if (/\.co\.id$/.test(window.location.host)) {
            accsAserverUrl = 'msgacs-wapa.lazada.co.id';
        }
        else {
            accsAserverUrl = 'msgacs-wapa.lazada.sg';
        }
        mtopDomain = "acs-wapa." + siteSuffix;
    }
    else {
        if (type === 'buyer') {
            accsAppKey = 'H5_24814220';
        }
        else if (type === 'seller') {
            accsAppKey = 'H5_24813843';
        }
        if (/(daraz|shop)/.test(window.location.host)) {
            accsAserverUrl = 'msgacs-m.lazada.sg';
        }
        else {
            accsAserverUrl = "msgacs-m." + siteSuffix;
        }
        mtopDomain = "acs-m." + siteSuffix;
    }
    if (window.location.host === 'sellercenter-hk.taobao.net') {
        accsAserverUrl = 'msgacs-waptest.h5accs.taobao.hk';
        mtopDomain = 'acs.waptest-seller.hk.taobao.net';
        accessKey = 'hk-pc-h5';
        accessToken = 'hk-secret';
        accsAppKey = 'H5_27972444';
    }
    else if (window.location.host === 'sellercenter-hk-pre.taobao.global') {
        accsAserverUrl = 'msgacs-wapa.h5accs.taobao.global';
        mtopDomain = 'acs-wapa-hk.taobao.global';
        accessKey = 'hk-pc-h5';
        accessToken = 'hk-secret';
        accsAppKey = 'H5_24813843';
    }
    else if (window.location.host === 'sellercenter-hk.taobao.global') {
        accsAserverUrl = 'msgacs-m.h5accs.taobao.global';
        mtopDomain = 'acs-m-hk.taobao.global';
        accessKey = 'hk-pc-h5';
        accessToken = 'hk-secret';
        accsAppKey = 'H5_24813843';
    }
    return {
        accessKey: accessKey,
        accessToken: accessToken,
        accsAppKey: accsAppKey,
        accsAserverUrl: accsAserverUrl,
        mtopDomain: mtopDomain,
    };
}
export function init(param) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    var accountType = parseInt(param.accountType);
    accountType = Normal.userTypeMap.indexOf(accountType) > -1 ? accountType : 1;
    var nConfig = getMtopAccsConfig(undefined, param.env, param.channel);
    var bConfig = getMtopAccsConfig('buyer', param.env, param.channel);
    var sConfig = getMtopAccsConfig('seller', param.env, param.channel);
    var accessKey = nConfig.accessKey, accessToken = nConfig.accessToken;
    Buyer.accsAppKey = bConfig.accsAppKey;
    Seller.accsAppKey = sConfig.accsAppKey;
    Normal.accsAserverUrl = nConfig.accsAserverUrl;
    if (param.env === 'daily') {
        Buyer.mtopDomain = bConfig.mtopDomain;
        Seller.mtopDomain = sConfig.mtopDomain;
    }
    else if (param.env === 'pre') {
        Normal.mtopDomain = nConfig.mtopDomain;
    }
    else {
        Normal.mtopDomain = nConfig.mtopDomain;
    }
    Normal.serviceId = ACCS_SERVICE_ID_MAP[param.region] || 'lz-sync';
    var config = Object.assign({
        userId: '',
        _guid: createGuid(),
    }, Normal, accountType === 1 ? Buyer : Seller, param, {
        appKey: param.appKey,
        accountType: accountType,
        fromCode: (_a = param.fromCode) !== null && _a !== void 0 ? _a : '',
        accessKey: (_b = param.accessKey) !== null && _b !== void 0 ? _b : accessKey,
        accessToken: (_c = param.accessToken) !== null && _c !== void 0 ? _c : accessToken,
        region: (_d = param.region) !== null && _d !== void 0 ? _d : 'cn',
        lang: (_e = param.lang) !== null && _e !== void 0 ? _e : 'en',
        sessionFetchCount: param.sessionFetchCount,
        delayTime: param.delayTime !== undefined ? param.delayTime : 500,
        accs: (_f = param.accs) !== null && _f !== void 0 ? _f : null,
        mtop: (_g = param.mtop) !== null && _g !== void 0 ? _g : null,
        shouldFilterShunted: param.shouldFilterShunted,
        channel: (_h = param.channel) !== null && _h !== void 0 ? _h : 'normal',
    }, param.sdkConfig);
    config._url = initUrl(config);
    return config;
}
